import React from "react";
import { Card } from "./TvBits";

const ST = { hit: ["HIT", "#10B981"], miss: ["MISS", "#EF4444"], pending: ["PENDING", "#64748B"] };

const Chip = ({ p }) => {
  const [lbl, c] = ST[p.status];
  return (
    <div className="flex items-center gap-2 rounded-xl px-3 py-2 border" style={{ borderColor: `${c}55`, background: `${c}12` }} data-testid="tv-record-pick">
      <span className="nx-mono text-[10px] font-black tracking-widest px-1.5 rounded" style={{ color: "#030712", background: p.call === "BUY" ? "#10B981" : "#EF4444" }}>{p.call}</span>
      <b className="nx-orbitron text-xl font-black text-cyan-50">{p.ticker}</b>
      {p.move_pct != null && <span className="nx-mono text-sm" style={{ color: p.move_pct >= 0 ? "#10B981" : "#EF4444" }}>{p.move_pct > 0 ? "+" : ""}{p.move_pct}%</span>}
      <span className="nx-mono text-xs font-black tracking-widest ml-auto" style={{ color: c }}>{lbl}</span>
    </div>
  );
};

const day = (s) => new Date(`${s}T12:00:00`).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" }).toUpperCase();

export const TvDigestRecord = ({ d }) => {
  const rows = d.digest_record || [];
  const hits = rows.reduce((a, r) => a + r.hits, 0), done = rows.reduce((a, r) => a + r.checked, 0);
  return (
    <Card title="DIGEST TRACK RECORD" accent="#A78BFA" code={done ? `${hits}/${done} HIT · ${Math.round((hits / done) * 100)}%` : "CHECKS 24H AFTER EACH DIGEST"} className="h-full" testid="tv-scene-record">
      <div className="h-full flex flex-col gap-3 overflow-hidden">
        {rows.slice(0, 6).map((r) => (
          <div key={r.date} className="flex items-start gap-4" data-testid="tv-record-day">
            <div className="w-40 shrink-0">
              <p className="nx-orbitron text-lg font-black text-cyan-100">{day(r.date)}</p>
              <p className="nx-mono text-sm" style={{ color: r.hit_rate == null ? "#64748B" : r.hit_rate >= 60 ? "#10B981" : r.hit_rate >= 40 ? "#F59E0B" : "#EF4444" }}>
                {r.hit_rate == null ? "PENDING" : `${r.hits}/${r.checked} · ${r.hit_rate}%`}
              </p>
            </div>
            <div className="flex-1 grid grid-cols-4 gap-2">{r.picks.slice(0, 8).map((p, i) => <Chip key={p.ticker + i} p={p} />)}</div>
          </div>
        ))}
      </div>
    </Card>
  );
};
